module.exports = {"modelSvg":"assets/melanocyte.svg","bounds":{"left":565,"top":180,"width":200,"height":125},"species":["organelles/melanosome.yml","organelles/hexagon.yml","organelles/triangle.yml","organelles/g-protein.yml","organelles/g-protein-body.yml","organelles/g-protein-part.yml"],"calculatedProperties":{"lightness":{"ratio":{"numerator":{"count":{"species":"melanosome","rules":{"fact":{"not":"isDark"}}}},"denominator":{"count":{"species":"melanosome","rules":{"fact":"isDark"}}}}}},"hotStart":1500}


//////////////////
// WEBPACK FOOTER
// ./src/cell-models/receptor.json
// module id = 327
// module chunks = 0